import _ from "lodash";
import React from "react";
import {PiCurrencyCircleDollar} from "react-icons/pi";
import {marked} from "marked";

// Utility Service
import {getCurrencyText} from "../../utils";

const Index = (props) => {
    let markdownText;
    let htmlText;
    if (props?.individualData?.description) {
        markdownText = props?.individualData?.description.replace(/--/g, "\n\n---\n\n");
        htmlText = marked(markdownText);
    }

    return (
        <div className="p-3 border-rounded border price-box-shadow rounded-4">
            {!props?.singleVenue && props?.individualData?.facilities?.length > 0 && (
                <div className="mb-3">
                    <span className="fs-18 fw-bold">
                        <PiCurrencyCircleDollar size={24} className="me-1 fw-bold" />
                        Pricing: {getCurrencyText(props?.individualData?.info?.country)}{" "}
                        {_.min(
                            props?.individualData?.facilities?.map((item) =>
                                parseFloat(item?.min_price)
                            )
                        )}
                        -
                        {_.max(
                            props?.individualData?.facilities?.map((item) =>
                                parseFloat(item?.max_price)
                            )
                        )}{" "}
                        / hour
                    </span>
                </div>
            )}
            <p className="fw-bold fs-12">Normal Operating Hours: </p>
            <div className="pricing-description-div" dangerouslySetInnerHTML={{__html: htmlText}} />
            <hr />
        </div>
    );
};
export default Index;
